import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PagetagService } from 'src/app/services/pagetag.service';
import { AlertService } from 'src/app/services/alert.service';
import { BaseTableComponent } from '../base-table/base-table.component';
import { fuseAnimations } from '@mobileia/layout-fuse';

@Component({
  selector: 'app-pagetag',
  templateUrl: './pagetag.component.html',
  styleUrls: ['./pagetag.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class PagetagComponent extends BaseTableComponent<any> implements OnInit {

  displayedColumns = ['id', 'title', 'meta', 'actions'];
  configColumns = [
    {
      key: 'id',
      field_key: 'id',
      type: 'integer',
      title: 'ID',
      classes: 'font-weight-600'
    },
    {
      key: 'title',
      field_key: 'title',
      type: 'string',
      title: 'Titulo',
      classes: ''
    },
    {
      key: 'meta',
      field_key: 'meta',
      type: 'string',
      title: 'Descripción',
      classes: ''
    },
  ];

  constructor(
    protected pagetagService: PagetagService,
    protected alertService: AlertService
  ) {
    super(alertService);
    this.service = pagetagService;
  }

  ngOnInit(): void {
    this.loadItems();
  }

}